<cam-ag-grid-base-header [params]="this.params" class="flex-full">
  {{ this.params.displayName | translate }}
</cam-ag-grid-base-header>
